import { ChartTypeConfig } from './ChartTypeConfig';
import { SeriesType } from '../utils/SeriesType';
import { BasicChart, SeriesOption } from '../utils/models';

export class GaugeChartConfig implements ChartTypeConfig {
  getConfig(categories: string[], data: SeriesOption[], colors: string[]): Partial<BasicChart> {
    return {
      series: [{
        type: SeriesType.Gauge,
        detail:  {formatter: (value) => value +'%'},
        data: [{ value: data[0], name: categories[0] }]
      }],
      xAxis: undefined,
      yAxis: undefined,
    };
  }
}
